module.exports = __webpack_public_path__ + "static/media/users-class.6538aa54.svg";